import { Question } from './question';
import { Answers } from './answers';

export interface ReservationQuestionInfo {
  Questions: Question[];
  Answers: Answers[];
}


export class ReservationQuestion {
  constructor() {
    this.Questions = [];
    this.Answers = [];
    this.QuestionsFinish = false;
  }

  public Questions: Question[];
  public Answers: Answers[];
  public QuestionsFinish: boolean;
  public IsQuestionsFinish(): boolean {
    return this.QuestionsFinish;
  }
}
